module.exports = Promise.resolve(module.bundle.root("25X2B"))